import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'SEARCH',
    entityName: 'SEARCH'
});

const initialState = {
    ...crudInitialState,
    lastSearchParams: false
};

const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }
    // Handle other actions
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        case 'HANDLE_SEARCH_SET':
                return {...state , ...action.search};
        case 'CLEAR_STATE_SEARCH':
            return {...state ,lastSearchParams: state.lastSearchParams , list:[] };
        default:
            return state;
    }
};

export default reducer;